import { useLocation } from "react-router-dom";
import { LocaleLink } from "@/components/LocaleLink";
import { LOCALE_PREFIXES } from "@/i18n";
import { useAuth } from "@/hooks/useAuth";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const MobileCTA = () => {
  const { user } = useAuth();
  const location = useLocation();
  const { t } = useTranslation();
  const [keyboardOpen, setKeyboardOpen] = useState(false);

  useEffect(() => {
    const threshold = window.innerHeight * 0.75;
    const onResize = () => {
      setKeyboardOpen(window.visualViewport ? window.visualViewport.height < threshold : false);
    };

    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", onResize);
      return () => window.visualViewport?.removeEventListener("resize", onResize);
    }
  }, []);

  // Extract locale prefix and base path from URL
  const segments = location.pathname.split("/").filter(Boolean);
  const firstSegment = segments[0] || "";
  const isLocalePrefixed = LOCALE_PREFIXES.some((p) => p.prefix === firstSegment);
  if (!isLocalePrefixed) return null; // Don't show on root language selector

  const basePath = "/" + segments.slice(1).join("/") || "/";
  const conversionPaths = ["/", "/fuer-handwerker", "/suche", "/ueber-uns", "/kontakt"];
  const showCTA = conversionPaths.includes(basePath) && !user;

  if (!showCTA || keyboardOpen) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-background/95 backdrop-blur-sm border-t border-border"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
    >
      <nav aria-label="Schnellzugriff" className="flex gap-2 px-4 py-3">
        <LocaleLink
          to="/inquiry"
          className="flex-1 text-center py-3 bg-primary text-primary-foreground text-sm font-medium min-h-[44px] flex items-center justify-center"
        >
          {t("mobileCta.submitInquiry")}
        </LocaleLink>
        <LocaleLink
          to="/registrieren"
          className="flex-1 text-center py-3 border border-border text-sm text-foreground min-h-[44px] flex items-center justify-center"
        >
          {t("mobileCta.craftBusiness")}
        </LocaleLink>
      </nav>
    </div>
  );
};

export default MobileCTA;
